@for (item of items(); track item; let i = $index) {
    <div class="p-5" @verticalCollapse @triggerChildAnimation @slideIn @slideOut>
        <app-toast-item [type]="item.type" [message]="item.message" [duration]="item.duration" (dismiss)="dismissItem(i)"> </app-toast-item>
    </div>
}
